<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
        <v-card>
          <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
            <v-row>
              <v-col 
                cols="12"
                sm="10"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      small
                      exact
                      color="primary"
                      class="mr-4"
                      v-bind="attrs"
                      v-on="on"
                      @click="regresar"
                    >
                      <v-icon> mdi-arrow-left </v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar</span>
                </v-tooltip>
                Gestionar Experto Nacional: {{ habilidadCompetenciaWS.categoria }}
              </v-col>

              <v-col 
                cols="12"
                sm="2"
                class="d-flex justify-end"
              >
                <v-btn
                  exact
                  color="primary"
                  @click="open"
                >
                  Registrar
                </v-btn> 
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            fixed-header
            height="calc(100vh - 220px)"
            class="elevation-2"
            :headers="headersTable"
            :items="expertosNacionales"
            :footer-props="{ 'items-per-page-options': [10, 20, -1] }"
          >
          <template v-slot:[`item.acciones`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="detalles(item.id)"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>Detalles</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="editar(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Actualizar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarAlertaEliminar(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>

            <template v-slot:top>
              <v-dialog 
                persistent 
                v-model="dialogForm" 
                max-width="520px"
              >
                <v-card :loading="loadingForm">
                  <v-card-title class="justify-center">
                    <p class="text-h5 font-weight-bold primary--text">
                      {{ formTitle }}
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-col 
                          cols="12"
                          sm="10"
                        >
                          <v-form 
                            ref="form" 
                            v-model="form"
                          >
                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Competencia"
                              v-model="competenciaSeleccionada"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Habilidad"
                              v-model="habilidadSeleccionada"
                            >
                            </v-text-field>

                            <v-select
                              outlined
                              dense
                              label="Regional*"
                              :items="regionales"
                              item-value="id"
                              item-text="regional"
                              v-model="regional"
                              :rules="regionalReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              label="Centro de Formación*"
                              :items="centrosFormacion"
                              item-value="id"
                              item-text="centro_formacion"
                              v-model="centroFormacion"
                              :rules="centroFormacionReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              label="Tipo de Identificación*"
                              :items="tiposIdentificacion"
                              item-value="id"
                              item-text="tipo_identificacion"
                              v-model="tipoIdentificacion"
                              :rules="tipoIdentificacionReglas"
                            >
                            </v-select>

                            <v-text-field
                              outlined
                              dense
                              :disabled="editedIndex == 1"
                              type="number"
                              label="Número de Identificación*"
                              min="1"
                              maxlength="10"
                              counter
                              v-model="identificacion"
                              :rules="identificacionReglas"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              type="text"
                              label="Nombres*"
                              maxlength="50"
                              counter
                              v-model.trim="nombres"
                              :rules="nombresReglas"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              type="text"
                              label="Apellidos*"
                              maxlength="50"
                              counter
                              v-model.trim="apellidos"
                              :rules="apellidosReglas"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              type="text"
                              label="Correo Electronico*"
                              maxlength="50"
                              counter
                              v-model.trim="correo"
                              :rules="correoReglas"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              type="number"
                              label="Telefono Movil*"
                              maxlength="10"
                              counter
                              v-model="telefonoMovil"
                              :rules="telefonoMovilReglas"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              type="text"
                              label="Direccion*"
                              maxlength="50"
                              counter
                              v-model.trim="direccion"
                              :rules="direccionReglas"
                            >
                            </v-text-field>

                            <v-dialog 
                              ref="fechaNacimiento" 
                              persistent
                              width="300px"
                              v-model="dialogFechaNacimiento" 
                              :return-value.sync="fechaNacimiento"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field 
                                  outlined 
                                  dense 
                                  readonly
                                  prepend-inner-icon="mdi-calendar" 
                                  label="Fecha de Nacimiento*" 
                                  v-model="fechaNacimiento" 
                                  :rules="fechaNacimientoReglas" 
                                  v-bind="attrs" 
                                  v-on="on"
                                >
                                </v-text-field>
                              </template>

                              <v-date-picker 
                                scrollable 
                                color="primary"
                                v-model="fechaNacimiento"
                              >
                                <v-spacer></v-spacer>
                                <v-btn 
                                  text 
                                  color="error" 
                                  @click="dialogFechaNacimiento = false"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn 
                                  text 
                                  color="primary" 
                                  @click="$refs.fechaNacimiento.save(fechaNacimiento)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>

                            <v-select
                              outlined
                              dense
                              label="Genero*"
                              :items="generos"
                              item-value="id"
                              item-text="genero"
                              v-model="genero"
                              :rules="generoReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              label="Estado Civil*"
                              :items="estadosCiviles"
                              item-value="id"
                              item-text="estado_civil"
                              v-model="estadoCivil"
                              :rules="estadoCivilReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              label="Estrato*"
                              :items="estratos"
                              item-value="id"
                              item-text="estrato"
                              v-model="estrato"
                              :rules="estratoReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              label="Zona*"
                              :items="zonas"
                              item-value="id"
                              item-text="zona"
                              v-model="zona"
                              :rules="zonaReglas"
                            >
                            </v-select>

                            <v-select
                              outlined
                              dense
                              label="Discapacidad*"
                              :items="discapacidades"
                              item-value="id"
                              item-text="discapacidad"
                              v-model="discapacidad"
                              :rules="discapacidadReglas"
                            >
                            </v-select>

                            <v-text-field
                              outlined
                              dense
                              type="text"
                              label="Cargo*"
                              maxlength="100"
                              counter
                              v-model.trim="cargo"
                              :rules="cargoReglas"
                            >
                            </v-text-field>
                            
                            <v-select
                              outlined
                              dense
                              label="Talla de Camiseta*"
                              :items="tallas"
                              v-model="talla"
                              :rules="tallaReglas"
                            >
                            </v-select>
                          </v-form>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      text 
                      color="error" 
                      @click="close"
                    >
                      Cancelar
                    </v-btn>

                    <template v-if="editedIndex === -1">
                      <v-btn 
                        text 
                        exact 
                        color="primary" 
                        @click="registrar"
                      >
                        Registrar
                      </v-btn>
                    </template>

                    <template v-else>
                      <v-btn 
                        text 
                        exact 
                        color="primary" 
                        @click="actualizar"
                      >
                        Actualizar
                      </v-btn>
                    </template>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog 
                v-model="dialogDelete" 
                max-width="480px"
              >
                <v-card>
                  <v-card-title class="justify-center text-h5">
                    ¿Desea eliminar el experto nacional?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      text 
                      color="primary" 
                      @click="closeDelete"
                    >
                      Cancelar
                    </v-btn>

                    <v-btn 
                      text 
                      color="error" @click="eliminar"
                    > 
                      OK 
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
        </v-card>
    </template>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Identificación",
        value: "identificacion",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      
      {
        text: "Nombres",
        value: "nombres",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Apellidos",
        value: "apellidos",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Regional",
        value: "regional",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Centro de Formación",
        value: "centro_formacion",
        align: "start",
        width: "20%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,

    competenciaSeleccionada: "",
    habilidadSeleccionada: "",

    regional: null,
    regionalReglas: [
      (v) => !!v || "Seleccione una regional"
    ],

    centroFormacion: null,
    centroFormacionReglas: [
      (v) => !!v || "Seleccione un centro de formación"
    ],

    tipoIdentificacion: null,
    tipoIdentificacionReglas: [
      (v) => !!v || "Seleccione un tipo de Identififcacion",
    ],
    tiposIdentificacion: [
      { tipo_identificacion: "Tarjeta de Identidad", id: 1 },
      { tipo_identificacion: "Cedula de Ciudadania", id: 2 },
      { tipo_identificacion: "Documento Extranjero", id: 3 }
    ],

    identificacion: '',
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
      (v) => (v && v.length >= 6) || "Minimo 6 digitos",
    ],

    nombres: '',
    nombresReglas: [(v) => !!v || "Escriba los nombres"],

    apellidos: '',
    apellidosReglas: [(v) => !!v || "Escriba los apellidos"],

    correo: '',
    correoReglas: [
      (v) => !!v || "Escriba un correo electrónico",
      (v) => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],

    telefonoMovil: '',
    telefonoMovilReglas: [
      (v) => !!v || "Escriba un número de telefono movil",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos"
    ],

    direccion: '',
    direccionReglas: [(v) => !!v || "Escriba una dirección"],

    dialogFechaNacimiento: false,
    fechaNacimiento: null,
    fechaNacimientoReglas: [(v) => !!v || "Seleccione una fecha"],

    genero: null,
    generoReglas: [
      (v) => (!!v) || "Seleccione un genero",
    ],
    generos: [
      { genero: "Femenino", id: 1 },
      { genero: "Masculino", id: 2 },
    ],

    estadoCivil: null,
    estadoCivilReglas: [(v) => !!v || "Seleccione un estado civil"],
    estadosCiviles: [
      { estado_civil: "Viudo", id: 1 },
      { estado_civil: "Separado", id: 2 },
      { estado_civil: "Unión Libre", id: 3 },
      { estado_civil: "Casado", id: 4 },
      { estado_civil: "Soltero", id: 5 },
      { estado_civil: "Indiferente", id: 6 }
    ],

    estrato: null,
    estratoReglas: [(v) => !!v || "Seleccione un estrato"],
    estratos: [
      { estrato: 1, id: 1 },
      { estrato: 2, id: 2 },
      { estrato: 3, id: 3 },
      { estrato: 4, id: 4 },
      { estrato: 5, id: 5 },
      { estrato: 6, id: 6 },
    ],

    zona: null,
    zonaReglas: [(v) => !!v || "Seleccione una zona"],
    zonas: [
      { zona: "Urbana", id: 1 },
      { zona: "Rural", id: 2 },
    ],

    discapacidad: null,
    discapacidadReglas: [(v) => !!v || "Seleccione una discapacidad"],
    discapacidades: [
      { discapacidad: "Ninguna", id: 1 },
      { discapacidad: "Cognitiva", id: 2 },
      { discapacidad: "Fisica", id: 3 },
    ],

    cargo: '',
    cargoReglas: [
      (v) => !!v || "Escriba un cargo"
    ],

    talla: null,
    tallas: ["XS", "S", "M", "L", "XL", "XXL"],
    tallaReglas: [
      (v) => !!v || "Seleccione una talla"
    ],

    idExpertoNacional: null,
    idPersona: null,

    editedIndex: -1,
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch("gestionarExpertosNacionales", this.$route.params.id_competencia);
    this.$store.dispatch("gestionarCompetenciasWorldSkills");
    this.$store.dispatch("gestionarHabilidadesCompetencia", this.$route.params.id_competencia);
  
    setTimeout(() => {
      this.skeletonLoader = false;
    }, 2000);
  },

  computed: {
    expertosNacionales() {
      return this.$store.getters.obtenerExpertosNacionales.filter((experto) => experto.categoria_id == this.$route.params.id_categoria)
    },

    formTitle() {
      return this.editedIndex === -1 ? "Registrar Experto Nacional" : "Actualizar Experto Nacional";
    },

    habilidadCompetenciaWS() {
      return this.$store.getters.obtenerHabilidadCompetenciaWorldSkills(this.$route.params.id_competencia, this.$route.params.id_categoria);
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    },
  },

  watch: {
    dialogForm(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    }
  },

  methods: {
    open() {
      this.disabled = false;
      this.dialogForm = true;
      this.competenciaSeleccionada = this.habilidadCompetenciaWS.competencia;
      this.habilidadSeleccionada = this.habilidadCompetenciaWS.categoria;
    },

    deleteItemConfirm() {
      this.dialogDelete = false;
    },

    close() {
      this.dialogForm = false;
      this.editedIndex = -1;
      this.$refs.form.reset();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    registrar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const expertoNacional = {
          competencia_id:       this.$route.params.id_competencia,
          categoria_id:         this.$route.params.id_categoria,
          centro_formacion_id:  this.centroFormacion,
          tipo_lider_id:        5,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          cargo:                  this.cargo,
          talla_camiseta:         this.talla
        };

        this.loadingForm = true;
        this.$store.dispatch("registrarExpertoNacional", expertoNacional)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;
            this.close();
            
            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;
            
            this.skeletonLoader = true

            this.$store.dispatch("gestionarExpertosNacionales", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    detalles(idExperto) {
      this.$router.push({
        name: "expertows-nacional-detalles",
        params: { id_experto: idExperto },
      });
    },

    editar(idExperto) {
      this.editedIndex = 1;
      this.$store.dispatch("detallesExpertoNacional", idExperto);

      setTimeout(() => {
        const expertoNacional = this.$store.getters.obtenerExpertoNacional

        this.idExpertoNacional        = idExperto;
        this.competenciaSeleccionada  = this.habilidadCompetenciaWS.competencia;
        this.habilidadSeleccionada    = this.habilidadCompetenciaWS.categoria;
        this.regional                 = expertoNacional.regional_id;
        this.centroFormacion          = expertoNacional.centro_formacion_id;
        this.idPersona                = expertoNacional.persona_id;
        this.tipoIdentificacion       = expertoNacional.tipo_identificacion_id;
        this.identificacion           = expertoNacional.identificacion;
        this.nombres                  = expertoNacional.nombres;
        this.apellidos                = expertoNacional.apellidos;
        this.correo                   = expertoNacional.correo;
        this.telefonoMovil            = expertoNacional.telefono_movil;
        this.direccion                = expertoNacional.direccion;
        this.fechaNacimiento          = expertoNacional.fecha_nacimiento;
        this.genero                   = expertoNacional.genero_id;
        this.estadoCivil              = expertoNacional.estado_civil_id;
        this.estrato                  = expertoNacional.estrato;
        this.zona                     = expertoNacional.zona_id;
        this.discapacidad             = expertoNacional.discapacidad_id;
        this.cargo                    = expertoNacional.cargo;
        this.talla                    = expertoNacional.talla_camiseta;
      }, 1000);

      this.dialogForm = true;
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const expertoNacional = {
          id:                     this.idExpertoNacional,
          competencia_id:         this.$route.params.id_competencia,
          categoria_id:           this.$route.params.id_categoria,
          centro_formacion_id:    this.centroFormacion,
          tipo_lider_id:          5,
          id_persona:             this.idPersona,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          cargo:                  this.cargo,
          talla_camiseta:         this.talla
        };

        this.loadingForm = true;

        this.$store.dispatch("actualizarExpertoNacional", expertoNacional)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;
            this.close();
           
            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true;

            this.$store.dispatch("gestionarExpertosNacionales", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    activarAlertaEliminar(idexperto) {
      this.idExpertoNacional = idexperto;
      this.dialogDelete = true;
    },

    eliminar() {
      this.dialogDelete = false;
      this.$store.dispatch("eliminarExpertoNacional", this.idExpertoNacional)
      .then((response) => {
        if (response.status == "success") {
          let message       = response.message.split(',')
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;

          this.skeletonLoader = true;

          this.$store.dispatch("gestionarExpertosNacionales", this.$route.params.id_competencia);

          setTimeout(() => {
            this.alert = false;
            this.skeletonLoader = false;
          }, 1000);
        }
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }
          
          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    regresar() {
      this.$router.back()
    }
  },
};
</script>
